import { SupportedLocale } from "@shoptet/ui";

const UI_LOCALES: { [language: string]: SupportedLocale } = {
  cs: "cs-CZ",
  de: "de-DE",
  en: "en-US",
  hu: "hu-HU",
  pl: "pl-PL",
  ro: "ro-RO",
  sk: "sk-SK",
  vi: "vi-VN",
};

const DEFAULT_UI_LOCALE: SupportedLocale = "cs-CZ";

// @shoptet/ui's LocalizationProvider wants a full locale, we only carry the language code around.
export const getUiLocale = (language?: string): SupportedLocale =>
  UI_LOCALES[(language || "").slice(0, 2).toLowerCase()] || DEFAULT_UI_LOCALE;
